import script from "./TSideMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./TSideMenu.vue?vue&type=script&setup=true&lang=ts"

import "./TSideMenu.vue?vue&type=style&index=0&id=e6164468&lang=scss"

const __exports__ = script;

export default __exports__